import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Input, Label } from "rbx";

import { SystemCodeSelect, PoorTextEditor, DateInput } from "../inputs";

const EmployeeCertificationForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field kind="group">
      <Control expanded>
        <Label>Certification Name</Label>
        <Input
          autocomplete="new"
          name="CertificationName"
          type="text"
          value={inputs.CertificationName}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <SystemCodeSelect
          required
          icon="certificate"
          label="Certification Type"
          lookup={{
            Category: "Employee",
            Code: "Certifications"
          }}
          name="CertificationTypeRecIdRef"
          size=""
          value={inputs.CertificationTypeRecIdRef}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field kind="group">
      <Control expanded>
        <Label>Last Test Date</Label>
        <DateInput
          name="LastTestDate"
          value={inputs.LastTestDate}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Expiration Date</Label>
        <DateInput
          name="ExpirationDate"
          value={inputs.ExpirationDate}
          onChange={onChange}
        />
      </Control>
    </Field>

    <Field>
      <Control>
        <Label>Note</Label>
        <PoorTextEditor name="Note1" value={inputs.Note1} onChange={onChange} />
      </Control>
    </Field>
  </React.Fragment>
);
EmployeeCertificationForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
EmployeeCertificationForm.defaultProps = {
  inputs: {}
};

export default EmployeeCertificationForm;
